module.exports = __webpack_public_path__ + "static/media/download-img1.9b7a0c55.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download-img1.svg
// module id = 383
// module chunks = 0